import { USStateMapping } from '@rategravity/core-lib/enums';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import Card from '../../components/card';

const State = ({ target, onChange, model, ...cardProps }) => (
  <Card {...cardProps}>
    <SelectField
      style={{ maxWidth: 256, width: '100%' }}
      maxHeight={300}
      labelStyle={{ paddingLeft: 0 }}
      underlineStyle={{ margin: '-1px 24px -1px 0' }}
      value={model.get(target)}
      floatingLabelText="Select a State"
      onChange={(event, _, payload) => onChange(target, payload)}
    >
      {USStateMapping.map((state, i) => (
        <MenuItem key={i} value={state.abbreviation} primaryText={state.name} />
      ))}
    </SelectField>
  </Card>
);

export default State;



// WEBPACK FOOTER //
// ./src/cards/state/state.js